import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAssignSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M12.6667 2.00002H9.88C9.6 1.22669 8.86667 0.666687 8 0.666687C7.13333 0.666687 6.4 1.22669 6.12 2.00002H3.33333C2.6 2.00002 2 2.60002 2 3.33335V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33335C14 2.60002 13.4 2.00002 12.6667 2.00002ZM12.6667 12.6667H3.33333V3.33335H12.6667V12.6667ZM8 4.00002C6.9 4.00002 6 4.90002 6 6.00002C6 7.10002 6.9 8.00002 8 8.00002C9.1 8.00002 10 7.10002 10 6.00002C10 4.90002 9.1 4.00002 8 4.00002ZM4 10.98V12H12V10.98C12 9.31335 9.35333 8.59335 8 8.59335C6.64667 8.59335 4 9.30669 4 10.98Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
